var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("h1", [_vm._v("Verified by GS1")]),
      _vm._v(" "),
      _vm.showBacklink
        ? _c("div", { staticClass: "backlink" }, [
            _c("p", [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      _vm.$router.go(-1)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "fa fa-chevron-left" }),
                  _vm._v(" " + _vm._s(_vm.$t("back")) + "\n      ")
                ]
              )
            ])
          ])
        : [
            _c("search-form", {
              staticStyle: { "margin-top": "40px" },
              on: { error: _vm.setError, submit: _vm.submit },
              model: {
                value: _vm.searchCopy,
                callback: function($$v) {
                  _vm.searchCopy = $$v
                },
                expression: "searchCopy"
              }
            })
          ],
      _vm._v(" "),
      _vm.error
        ? _c("search-form-alerts", {
            attrs: { error: _vm.error },
            on: { suggest: _vm.applySuggestion }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loading ? _c("gs1-alert-loading") : _vm._e(),
      _vm._v(" "),
      [
        _vm.gtinsVerifiedResponse
          ? _c("result-data", {
              attrs: {
                gtinsVerifiedResponse: _vm.gtinsVerifiedResponse,
                glnsVerifiedResponse: _vm.glnsVerifiedResponse,
                gs1Id: _vm.search,
                mainLicensesVerifiedResponse: _vm.mainLicensesVerifiedResponse
              }
            })
          : _vm.notFound
          ? _c("gs1-alert-not-found")
          : _vm.companyName
          ? _c("result-no-data", { attrs: { companyName: _vm.companyName } })
          : _vm._e()
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eb31788a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb31788a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/router/views/Result.vue
// module id = null
// module chunks = 